const header = {
  homepage: 'sifeddinehadi',
  title: 'sifeddine.com',
}

const about = {
  name: 'Sif eddine HADI',
  role: 'Software Developer',
  description:
    'I am a passionate full-stack developer, with solid experience in web application design and development, I have had the opportunity to work on various projects, ranging from corporate websites to SaaS applications, through innovative prototypes. My problem-solving approach and team spirit have allowed me to successfully contribute to the development of tailor-made solutions that meet specific customer needs.',
  resume: '#',
  social: {
    linkedin: 'https://www.linkedin.com/in/sif-eddine-hadi-361037233/',
    github: 'https://github.com/sife22/',
  },
}

const projects = [
  {
    name: 'La Plume Curieuse',
    description:
      " : blog où nous pouvons partager différents articles.",
    stack: ['Html5', 'Css3', 'ReactJs - RTK', 'Laravel', 'MySQL', 'Git'],
    sourceCode: 'https://github.com/sife22',
    livePreview: '#',
  },
  {
    name: 'PureTalk-App',
    description:
      'Un projet qui utilise Reactjs et Firebase pour élaborer une application de chat conviviale.',
    stack: ['Html5', 'Css3', 'ReactJs', 'Firebase', 'Git'],
    sourceCode: 'https://github.com/sife22/puretalk-app',
    livePreview: 'https://puretalk-app.netlify.app/',
  },
  {
    name: 'LinkedIn Clone',
    description:
      'Clonage de la plateforme LinkedIn en utilisant ReactJs et Firebase',
    stack: ['Html5', 'Css3', 'ReactJs', 'Firebase', 'Git'],
    sourceCode: 'https://github.com/sife22/linkedin-clone',
    livePreview: 'https://linkedin-clone-reactjs-app.vercel.app/',
  },
  {
    name: 'Weather App',
    description:
      'Il s’agit d’un TP réalisé avec ReactJs. Les utilisateurs ont la possibilité de rechercher des informations météorologiques pour leurs différentes villes.',
    stack: ['Html5', 'Css3', 'JavaScript', 'ReactJs'],
    sourceCode: 'https://github.com/sife22/weather-reactjs',
    livePreview: 'https://weather-app-reactjs-master.netlify.app/',
  },
  // {
  //   name: 'Autobahn-pfe',
  //   description:
  //     'It is a small platform that manages a car rental agency, realized using Laravel...',
  //   stack: ['Html5', 'Css3', 'JavaScript', 'PHP', 'Laravel', 'MySQL', 'UML'],
  //   sourceCode: 'https://github.com/sife22/autobahn-pfe',
  //   livePreview: '#',
  // },
  // {
  //   name: 'And other projects',
  //   description:
  //     'And other projects using the techniques stack below',
  //   stack: [],
  //   sourceCode: '#',
  //   livePreview: '#',
  // },
]

const skills = [
  {
    name: 'HTML',
    logo: 'fa-brands fa-html5'
  },
  {
    name: 'CSS',
    logo: 'fa-brands fa-css3-alt'
  }, {
    name: 'Bootstrap',
    logo: 'fa-brands fa-bootstrap'
  }, {
    name: 'Material UI',
    logo: 'fa-solid fa-pen-nib'
  }, {
    name: 'JavaScript',
    logo: 'fa-brands fa-js'
  }, {
    name: 'PHP',
    logo: 'fa-brands fa-php'
  }, {
    name: 'Laravel',
    logo: 'fa-brands fa-laravel'
  }, {
    name: 'Symfony',
    logo: 'fa-brands fa-symfony'
  },
  {
    name: 'ReactJs',
    logo: 'fa-brands fa-react'
  },
  {
    name: 'Redux',
    logo: 'fa-brands fa-react'
  },
  {
    name: 'Redux TK',
    logo: 'fa-brands fa-react'
  }, {
    name: 'Firebase',
    logo: 'fa-solid fa-fire'
  },
  {
    name: 'Python',
    logo: 'fa-brands fa-python'
  }
  , {
    name: 'Flask',
    logo: 'fa-brands fa-python'
  }, {
    name: 'Django',
    logo: 'fa-brands fa-python'
  },
  {
    name: 'Wordpress',
    logo: 'fa-brands fa-wordpress-simple'
  },
  {
    name: 'Drupal',
    logo: 'fa-brands fa-drupal'
  }
  ,
  {
    name: 'MySQL',
    logo: 'fa-solid fa-database'
  }, {
    name: 'MongoDB',
    logo: 'fa-solid fa-database'
  }, {
    name: 'Git',
    logo: 'fa-brands fa-git-alt'
  },
  {
    name: 'Azure',
    logo: 'fa-solid fa-cloud'
  },
  ,
  {
    name: 'Docker',
    logo: ''
  },
  {
    name: 'Netlify',
    logo: ''
  },
  {
    name: 'Vercel',
    logo: ''
  },
  {
    name: 'Jira',
    logo: ''
  }
]

/* ---------------------------------------------------------------------------
 * experience — source de vérité unique
 *
 * La carte de la liste ET la modale de détail lisent le même objet : pas de
 * deuxième tableau à maintenir. Les champs « détaillés » (summary*,
 * highlights*, stack, links) ne sont lus que par la modale.
 *
 *   id               identifiant stable : clé React + cible de restauration
 *                    du focus à la fermeture (ne pas réutiliser uniqid())
 *   company          nom affiché
 *   roleEn / roleFr  intitulé du poste (convention bilingue déjà en place)
 *   startYear /      'YYYY-MM' ou 'YYYY' (voir formatDate dans Experience.js)
 *   endYear          absent si le poste est en cours
 *   current          true = poste en cours -> bordure accent + « Présent »
 *   logo             URL ou null (initiales générées en repli)
 *   summaryEn / Fr   2-3 phrases de contexte
 *   highlightsEn/Fr  réalisations, avec des chiffres quand il y en a
 *   stack            technos (chips)
 *   links            [{ label, href }] — optionnel
 *
 * Les champs détaillés sont volontairement vides : à remplir. Chaque section
 * de la modale ne s'affiche que si son champ est non vide, donc tant qu'ils
 * le sont la modale n'affiche que l'en-tête (entreprise, poste, période).
 * ------------------------------------------------------------------------- */
const experience = [
  {
    id: 'oxial',
    company: 'Oxial',
    roleEn: 'Developer & Consultant',
    roleFr: 'Développeur & Consultant',
    startYear: '2024-12',
    current: true,
    logo: 'https://cdn.prod.website-files.com/6541951b0dd38a1fe832560a/6541f722c14c94fa2c7fa402_Favicon%20Big.webp',
    summaryEn: '',
    summaryFr: '',
    highlightsEn: [],
    highlightsFr: [],
    stack: [],
    links: [],
  },
  {
    id: 'lycom-consulting',
    company: 'Lycom Consulting',
    roleEn: 'Full-Stack Developer',
    roleFr: 'Développeur Full-Stack',
    startYear: '2023-12',
    endYear: '2024-05',
    current: false,
    logo: 'https://media.theirstack.com/company/logo/domain/lycom.ma.jpeg',
    summaryEn: '',
    summaryFr: '',
    highlightsEn: [],
    highlightsFr: [],
    stack: [],
    links: [],
  },
  {
    id: 'toubkal-marketing',
    company: 'Toubkal Marketing',
    roleEn: 'Full-Stack Developer - Internship',
    roleFr: 'Développeur Full-Stack - Stage',
    startYear: '2023-07',
    endYear: '2023-09',
    current: false,
    logo: 'https://toubkal-marketing.com/log.png',
    summaryEn: '',
    summaryFr: '',
    highlightsEn: [],
    highlightsFr: [],
    stack: [],
    links: [],
  },
  {
    id: 'mission-conseil',
    company: 'Mission Conseil',
    roleEn: 'Full-Stack Developer - Internship',
    roleFr: 'Développeur Full-Stack - Stage',
    startYear: '2023-04',
    endYear: '2023-05',
    current: false,
    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeq0zGk-KWQngjU5IfnRaEsdsY7wMTA8dmFQa3uBWzw6vKcMXxlhWg4NE&s=10',
    summaryEn: '',
    summaryFr: '',
    highlightsEn: [],
    highlightsFr: [],
    stack: [],
    links: [],
  },
]

const contact = {
  email: 'sifeddinehadi22@gmail.com',
}

export { header, about, projects, skills, experience, contact }
